import React from "react";
import ReactDOM from "react-dom";
import Main from "./Entryfile/Main";
import { Provider } from "react-redux";
import "./index.css";
import registerServiceWorker from "./serviceWorkerRegistration";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// React 18 use ReactDOM.createRoot()
// See https://react.dev/blog/2022/03/08/react-18-upgrade-guide
// const container = document.getElementById('app');
// const root = createRoot(container);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <DndProvider backend={HTML5Backend}>
        <Main />
      </DndProvider>
    </PersistGate>
  </Provider>,

  document.getElementById("app")
);

if (module.hot) {
  // enables hot module replacement if plugin is installed
  module.hot.accept();
}
registerServiceWorker();
// serviceWorker.register();
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/service-worker.js")
//       .then((registration) => {
//         console.log("SW registered: ", registration);
//       })
//       .catch((registrationError) => {
//         console.log("SW registration failed: ", registrationError);
//       });
//   });
// }
